module.exports = __webpack_public_path__ + "static/sp_hell-3f176ab33c7db3f6549c72ca6ed71809.png";